import React, { Component } from 'react';
import { formatCurrency } from '@C/TableGrid';
import { Users } from 'lucide-react';

export class DSRSalary extends Component {
  constructor() {
    super();
    this.state = {
      tab: 1,
    };
  }

  render() {
    const summary = this.props.summary;
    return (
      <>
        <section className="widget dsr-table">
          <header>
            <Users color="#31af36" />
            <h3>Staff Salary</h3>
          </header>
          <main className="content-wrapper">
            <table className="dsr" data-name="Salary">
              <thead>
                <tr data-header={true}>
                  <th>#</th>
                  <th> Staff </th>
                  <th> Type</th>
                  <th> Given by</th>
                  <th> Amount </th>
                </tr>
              </thead>
              <tbody>
                {summary.map((val, key) => {
                  return (
                    <tr key={key}>
                      <td>{key + 1}</td>
                      <td>{`${val.staff_first_name} ${val.staff_last_name}`}</td>
                      <td>{val.type}</td>
                      <td>{`${val.given_received_by_staff_first_name} ${val.given_received_by_staff_last_name}`}</td>
                      <td>{formatCurrency(val.amount)}</td>
                    </tr>
                  );
                })}
                <tr className="summary-row">
                  <td colSpan="4">Total </td>
                  <td>
                    {formatCurrency(
                      summary.reduce((a, b) => a + (b['amount'] || 0), 0) || 0,
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </main>
        </section>
      </>
    );
  }
}
